import React, { useState } from "react";
import FileUpload from "components/UI/FileUpload";
import { axiosCitajteo } from "common/api/axios/citajteo_axios";
import { FILE_UP_NAME } from "constant/file/file_constants";
import { UNIT_FILE_FIELDS_URL } from "./UnitFileFields.const";
import styled from "styled-components";
import UnitsFields from "./UnitsFields";
import { UnitFields } from "type/dl_unit/dl_unit.type";

const UnitFileFields = () => {
  const [fields, setFields] = useState<UnitFields[]>([]);

  const fileUploadHandle = (data: UnitFields[]) => {
    setFields(data);
    console.log("fileUploadHandle", data);
  };

  return (
    <Div>
      <div>Unos zapisa preko fajla</div>
      <FileUpload
        axiosInstance={axiosCitajteo}
        fileFieldName={FILE_UP_NAME}
        fileUploadHandle={fileUploadHandle}
        uploadUrl={UNIT_FILE_FIELDS_URL}
        multiple={false}
      />
      <UnitsFields fields={fields} setFields={setFields} />
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export default UnitFileFields;
